import $ from 'jquery'
import { apiUrl } from '../_CONSTANTS'

export const fetchNotificationsCurrent = (page = 1) => {
  let fetchUnreadNotificationsCurrent = new Promise((resolve, reject) => {
    $.ajax({
      type: `GET`,
      url: `${apiUrl}/self/notifications?page=${page}`,
      context: this
    })
    .done(function(data) { resolve(data) })
    .fail(function(jqXhr) { reject(jqXhr) });
  });
  return fetchUnreadNotificationsCurrent;
}

export const fetchUnreadNotificationsCurrent = () => {
  let fetchUnreadNotificationsCurrent = new Promise((resolve, reject) => {
    $.ajax({
      type: `GET`,
      url: `${apiUrl}/self/notifications/unread`,
      context: this
    })
    .done(function(data) { resolve(data) })
    .fail(function(jqXhr) { reject(jqXhr) });
  });
  return fetchUnreadNotificationsCurrent;
}

export const fetchUnreadNotificationsCountCurrent = () => {
  let fetchUnreadNotificationsCurrent = new Promise((resolve, reject) => {
    $.ajax({
      type: `GET`,
      url: `${apiUrl}/self/notifications_count/unread`,
      context: this
    })
    .done(function(data) { resolve(data) })
    .fail(function(jqXhr) { reject(jqXhr) });
  });
  return fetchUnreadNotificationsCurrent;
}

export const readNotificationsCurrent = () => {
  let fetchUnreadNotificationsCurrent = new Promise((resolve, reject) => {
    $.ajax({
      type: `PATCH`,
      url: `${apiUrl}/self/notifications/unread`,
      context: this,
      cache: false
    })
    .done(function(data) { resolve(data) })
    .fail(function(jqXhr) { reject(jqXhr) });
  });
  return fetchUnreadNotificationsCurrent;
}



// WEBPACK FOOTER //
// ./src/app/utilities/notifications.jsx